import { REPORT_TYPES, GRAPH_DATATYPE, QUALITATIVE_REPORT_LEVELS } from "../../../constants/app-constant";
//import { newFormatDataByRanking } from "./new-format-data-by-ranking";
//import { formatDataByTonality } from "./format-data-by-tonality";
//import { newFormatDataByTrend } from "./new-format-data-by-trend";
import { getRandomUniqueColor, getLineGraphFormat } from "./format-utils";
import {
    VERTICALS,
    GRAPH_TYPES,
    CONSTANTS,
    useDynamicEntityColors,
} from "../../../constants/app-constant";
import { publicationPrintGenreFilterList } from "../../NewsAndAnalysis/NewAnalysis/AnalysisGroup/filter-constant";

const { V_ONLINE, V_PRINT } = VERTICALS;
const { PIE, TABLE, BAR_STACKED_EQUAL_HEIGHT, LINE, BAR_VERTICAL } = GRAPH_TYPES;
const {
    REPORTS: { TYPES },
} = CONSTANTS;

const {
    ENTITY,
    KEYWORD,
    JOURNALIST,
    CITY,
    PUBLICATION,
} = QUALITATIVE_REPORT_LEVELS;

const {
    SOVEntityTrendCCM,
    SOVEntityTrendIndex,
    SOVEntityTrendNOA,
    SOVEntityTrendReach,
    SOVEntityTrendMAV,
    SOVEntityTrendWordCount,
    SOVEntityTonalityCCM,
    SOVEntityTonalityIndex,
    SOVEntityTonalityNOA,
    SOVEntityTonalityMAV,
    SOVEntityTonalityWordCount,
    SOVEntityTonalityReach,
    SOVJournalistTrendCCM,
    SOVJournalistTrendIndex,
    SOVJournalistTrendNOA,
    SOVJournalistTrendReach,
    SOVJournalistTrendMAV,
    SOVJournalistTrendWordCount,
    SOVJournalistTonalityCCM,
    SOVJournalistTonalityIndex,
    SOVJournalistTonalityNOA,
    SOVJournalistTonalityMAV,
    SOVJournalistTonalityWordCount,
    SOVJournalistTonalityReach,
    SOVKeywordTrendCCM,
    SOVKeywordTrendIndex,
    SOVKeywordTrendNOA,
    SOVKeywordTrendReach,
    SOVKeywordTrendMAV,
    SOVKeywordTrendWordCount,
    SOVKeywordTonalityCCM,
    SOVKeywordTonalityIndex,
    SOVKeywordTonalityNOA,
    SOVKeywordTonalityMAV,
    SOVKeywordTonalityWordCount,
    SOVKeywordTonalityReach,
    SOVPublicationTrendCCM,
    SOVPublicationTrendIndex,
    SOVPublicationTrendNOA,
    SOVPublicationTrendReach,
    SOVPublicationTrendMAV,
    SOVPublicationTrendWordCount,
    SOVPublicationTonalityCCM,
    SOVPublicationTonalityIndex,
    SOVPublicationTonalityNOA,
    SOVPublicationTonalityMAV,
    SOVPublicationTonalityWordCount,
    SOVPublicationTonalityReach,
    SOVCityTrendCCM,
    SOVCityTrendIndex,
    SOVCityTrendNOA,
    SOVCityTrendReach,
    SOVCityTrendMAV,
    SOVCityTrendWordCount,
    SOVCityTonalityCCM,
    SOVCityTonalityIndex,
    SOVCityTonalityNOA,
    SOVCityTonalityMAV,
    SOVCityTonalityWordCount,
    SOVCityTonalityReach,
} = REPORT_TYPES;

const {
    SOVEntityRankingOnline,
    SOVEntityRankingPrint,
    SOVEntityTrendOnline,
    SOVEntityTrendPrint,
    SOVEntityTonalityOnline,
    SOVEntityTonalityPrint,
    SOVJournalistRankingOnline,
    SOVJournalistRankingPrint,
    SOVJournalistTrendOnline,
    SOVJournalistTrendPrint,
    SOVJournalistTonalityOnline,
    SOVJournalistTonalityPrint,
    SOVKeywordRankingOnline,
    SOVKeywordRankingPrint,
    SOVKeywordTrendOnline,
    SOVKeywordTrendPrint,
    SOVKeywordTonalityOnline,
    SOVKeywordTonalityPrint,
    SOVPublicationRankingOnline,
    SOVPublicationRankingPrint,
    SOVPublicationTrendOnline,
    SOVPublicationTrendPrint,
    SOVPublicationTonalityOnline,
    SOVPublicationTonalityPrint,
    SOVCityRankingPrint,
    SOVCityTrendPrint,
    SOVCityTonalityPrint,
} = GRAPH_DATATYPE;


export const newFormatSOVData = (
    d = [],
    report_type,
    graphDataType,
    selectedInlineGraphType,
    selectedInlineSentiment,
    selectedInlineEntity,
) => {
    const { online, print } = graphDataType;
    const isEntityLevel =
        online === SOVEntityRankingOnline ||
        print === SOVEntityRankingPrint ||
        online === SOVEntityTrendOnline ||
        print === SOVEntityTrendPrint ||
        online === SOVEntityTonalityOnline ||
        print === SOVEntityTonalityPrint;

    const isJournalistLevel =
        online === SOVJournalistRankingOnline ||
        print === SOVJournalistRankingPrint ||
        online === SOVJournalistTrendOnline ||
        print === SOVJournalistTrendPrint ||
        online === SOVJournalistTonalityOnline ||
        print === SOVJournalistTonalityPrint;

    const isKeywordLevel =
        online === SOVKeywordRankingOnline ||
        print === SOVKeywordRankingPrint ||
        online === SOVKeywordTrendOnline ||
        print === SOVKeywordTrendPrint ||
        online === SOVKeywordTonalityOnline ||
        print === SOVKeywordTonalityPrint;

    const isPublicationLevel =
        online === SOVPublicationRankingOnline ||
        print === SOVPublicationRankingPrint ||
        online === SOVPublicationTrendOnline ||
        print === SOVPublicationTrendPrint ||
        online === SOVPublicationTonalityOnline ||
        print === SOVPublicationTonalityPrint;

    const isCityLevel =
        print === SOVCityRankingPrint ||
        print === SOVCityTrendPrint ||
        print === SOVCityTonalityPrint;

    const level =
        (isEntityLevel) ? ENTITY :
            (isJournalistLevel) ? JOURNALIST :
                (isPublicationLevel) ? PUBLICATION :
                    (isCityLevel) ? CITY :
                        (isKeywordLevel) ? KEYWORD :
                            "No Level";

    const isTrend =
        report_type === SOVEntityTrendCCM ||
        report_type === SOVEntityTrendMAV ||
        report_type === SOVEntityTrendNOA ||
        report_type === SOVEntityTrendIndex ||
        report_type === SOVEntityTrendWordCount ||
        report_type === SOVEntityTrendReach ||
        report_type === SOVJournalistTrendCCM ||
        report_type === SOVJournalistTrendMAV ||
        report_type === SOVJournalistTrendNOA ||
        report_type === SOVJournalistTrendIndex ||
        report_type === SOVJournalistTrendWordCount ||
        report_type === SOVJournalistTrendReach ||
        report_type === SOVPublicationTrendCCM ||
        report_type === SOVPublicationTrendMAV ||
        report_type === SOVPublicationTrendNOA ||
        report_type === SOVPublicationTrendIndex ||
        report_type === SOVPublicationTrendWordCount ||
        report_type === SOVPublicationTrendReach ||
        report_type === SOVCityTrendCCM ||
        report_type === SOVCityTrendMAV ||
        report_type === SOVCityTrendNOA ||
        report_type === SOVCityTrendIndex ||
        report_type === SOVCityTrendWordCount ||
        report_type === SOVCityTrendReach ||
        report_type === SOVKeywordTrendCCM ||
        report_type === SOVKeywordTrendMAV ||
        report_type === SOVKeywordTrendNOA ||
        report_type === SOVKeywordTrendIndex ||
        report_type === SOVKeywordTrendWordCount ||
        report_type === SOVKeywordTrendReach;

    const isTonality =
        report_type === SOVEntityTonalityCCM ||
        report_type === SOVEntityTonalityMAV ||
        report_type === SOVEntityTonalityNOA ||
        report_type === SOVEntityTonalityIndex ||
        report_type === SOVEntityTonalityWordCount ||
        report_type === SOVEntityTonalityReach ||
        report_type === SOVJournalistTonalityCCM ||
        report_type === SOVJournalistTonalityMAV ||
        report_type === SOVJournalistTonalityNOA ||
        report_type === SOVJournalistTonalityIndex ||
        report_type === SOVJournalistTonalityWordCount ||
        report_type === SOVJournalistTonalityReach ||
        report_type === SOVPublicationTonalityCCM ||
        report_type === SOVPublicationTonalityMAV ||
        report_type === SOVPublicationTonalityNOA ||
        report_type === SOVPublicationTonalityIndex ||
        report_type === SOVPublicationTonalityWordCount ||
        report_type === SOVPublicationTonalityReach ||
        report_type === SOVCityTonalityCCM ||
        report_type === SOVCityTonalityMAV ||
        report_type === SOVCityTonalityNOA ||
        report_type === SOVCityTonalityIndex ||
        report_type === SOVCityTonalityWordCount ||
        report_type === SOVCityTonalityReach ||
        report_type === SOVKeywordTonalityCCM ||
        report_type === SOVKeywordTonalityMAV ||
        report_type === SOVKeywordTonalityNOA ||
        report_type === SOVKeywordTonalityIndex ||
        report_type === SOVKeywordTonalityWordCount ||
        report_type === SOVKeywordTonalityReach;


    const currentMeasure = (report_type) => {
        const measures = {
            NOA: "article_count",
            CCM: "ccmtotal",
            MAV: "mavtotal",
            Index: "indextotal",
            WC: "wordcounttotal",
            Reach: "reachtotal",
        };
        const noaRegex = /noa/i;
        const ccmRegex = /ccm/i;
        const mavRegex = /mav/i;
        const indexRegex = /index/i;
        const wordCountRegex = /wordCount/i;
        const reachRegex = /reach/i;
        if (noaRegex.test(report_type)) {
            return measures.NOA;
        } else if (ccmRegex.test(report_type)) {
            return measures.CCM;
        } else if (mavRegex.test(report_type)) {
            return measures.MAV;
        } else if (indexRegex.test(report_type)) {
            return measures.Index;
        } else if (wordCountRegex.test(report_type)) {
            return measures.WC;
        } else if (reachRegex.test(report_type)) {
            return measures.Reach;
        } else {
            console.log("No report name match found");
            return;
        }
    }
    const measure = currentMeasure(report_type);
    if (isTrend) {
        return newFormatDataByTrend(d, level, selectedInlineGraphType, measure, selectedInlineEntity.value);
    }
    else if (isTonality) {
        return newFormatDataByTonality(d, level, selectedInlineGraphType, measure, selectedInlineSentiment.value, selectedInlineEntity.value);
    }
    else {
        return newFormatDataByRanking(d, level, selectedInlineGraphType, measure, selectedInlineEntity.value);
    }
};
//{labels: [], datasets: [], hcPieChartData: [{name, y, backgroundColor}]}
const newFormatDataByTonality = (d = [], level, graphType, currentMeasure, sentiment, entity) => {
    //format keyword level separately 
    const result = d;
    const graphData = result && result[result.sequence[0]].returnData.graphdata;
    const dataObj = result && result[result?.sequence[0]].returnData;
    const entities = dataObj && dataObj.entities;
    const tonalities = dataObj && dataObj.tonality;
    //const editions = dataObj && dataObj.editions;
    const measure = currentMeasure;//currentMeasure === "wordcounttotal" ? "wordcnttotal" : currentMeasure === "article_count" ? "articlecnt" : currentMeasure;
    const color = tonalities && getRandomUniqueColor(tonalities.length);
    const datasets = [];
    const hcPieChartData = [];
    const level1Keys = Object.keys(graphData);
    const level2Keys = [];
    level1Keys && level1Keys.forEach((date) => {
        const currLevel2KeyArray = Object.keys(graphData[date]);
        currLevel2KeyArray.length > 0 && currLevel2KeyArray.forEach((val, idx) => {
            if (level2Keys.indexOf(val) === -1) {
                level2Keys.push(val);
            }
        });
    });
    let loopData = [];
    let loopName = "";
    // if (level === ENTITY) {
    //     loopData = entities;
    //     loopName = "entity_name";
    // } else if (level === JOURNALIST) {
    //     loopData = dataObj && dataObj.journalist;
    //     loopName = "source_name";
    // } else if (level === KEYWORD) {
    //     loopData = dataObj && dataObj.keywords;
    // } else if (level === PUBLICATION) {
    //     const publications = dataObj && dataObj.publications;
    //     loopData = publications;
    //     loopName = "publication";
    // } else if (level === CITY) {
    //     loopData = level2Keys;
    // }

    let allData = [];
    for (let i = 0; i < level1Keys.length; ++i) {
        level2Keys && level2Keys.forEach((level2) => {
            if (level === ENTITY) {
                if (graphData[level1Keys[i]].hasOwnProperty(level2)) {
                    allData.push({
                        label: level2,
                        data: graphData[level1Keys[i]][level2],
                        entities: level2
                    });
                }
            } else {
                entities && entities.forEach((ent) => {
                    if (graphData[level1Keys[i]].hasOwnProperty(level2) && graphData[level1Keys[i]][level2].hasOwnProperty(ent.entity_name)) {
                        allData.push({
                            label: level2,
                            data: graphData[level1Keys[i]][level2][ent.entity_name],
                            entities: ent.entity_name
                        });
                    }
                })
            }

        })
    }

    allData.sort((a, b) => b.data[measure] - a.data[measure]);
    const sortedLabels = allData.map(e => e.label);
    let sortedLabelsList;
    if (level === CITY) sortedLabelsList = [...new Set(sortedLabels.map(x => x))]
    else sortedLabelsList = [...new Set(sortedLabels.map(x => x))].slice(0, 10)

    loopData = level2Keys;
    const labels = sortedLabels; //(level === KEYWORD || level === CITY) ? loopData : loopData && loopData.map((l) => l[loopName]);
    if (graphType === BAR_STACKED_EQUAL_HEIGHT) {
        // console.log("Fullstack graph");
        tonalities && tonalities.forEach((tonality, idx) => {
            const backgroundColor = color[idx];
            const barThickness = "flex";
            const borderColor = backgroundColor;
            const borderWidth = 1;
            const data = [];
            const fill = false;
            const lineTension = 0;
            sortedLabelsList && sortedLabelsList.forEach((elm, idx) => {
                const label = elm; //(level === KEYWORD || level === CITY) ? elm : elm[loopName];
                if (level === ENTITY && graphData.hasOwnProperty(tonality) && graphData[tonality].hasOwnProperty(label)) {
                    const currVal = parseData(graphData[tonality][label][measure], true);
                    data.push(currVal);
                }
                else if (graphData.hasOwnProperty(tonality) && graphData[tonality].hasOwnProperty(label) && graphData[tonality][label].hasOwnProperty(entity)) {
                    const currVal = parseData(graphData[tonality][label][entity][measure], true);
                    data.push(currVal);
                }
                else {
                    data.push(0);
                }
            });
            datasets.push({ label: tonality, backgroundColor, barThickness, borderColor, borderWidth, data, fill, lineTension });

        });
        return { labels, datasets };
    }
    else if (graphType === PIE && labels && labels.length && labels.length > 0) {
        // console.log("Pie graph", graphType, d);
        const legendSet = [];
        const legendSetLength = Math.ceil(loopData.length / 10);
        // for (let x = 1, y = 0; x <= legendSetLength; x++) {
        const pieSet = [];
        sortedLabelsList && sortedLabelsList.forEach((elm, idx) => {
            const name = elm; //(level === KEYWORD || level === CITY) ? elm : elm[loopName];;
            const backgroundColor = color && color[idx];
            let currVal = 0;
            if (level === ENTITY && graphData.hasOwnProperty(sentiment) && graphData[sentiment].hasOwnProperty(name)) {
                console.log('sortedLabelsList', sortedLabelsList)
                currVal = parseData(graphData[sentiment][name][measure], true);
            } else if (graphData.hasOwnProperty(sentiment) && graphData[sentiment].hasOwnProperty(name) && graphData[sentiment][name].hasOwnProperty(entity)) {
                currVal = parseData(graphData[sentiment][name][entity][measure], true);
            }
            pieSet.push({ name, y: currVal, backgroundColor });
        });
        legendSet.push({ labels, datasets, hcPieChartData: pieSet });
        // y = x * 10;
        // }
        return legendSet;
    }
    else {
        return { labels: [], datasets: [], hcPieChartData: [{}] };
    }
}
//{datasets: {label: "", backgroundColor: "", barThcikness: "", borderColor: ""/[], borderWidth: 1, data: [], fill: false, lineTension: 0}}
//{labels: [], datasets: [], hcPieChartData: [{name, y, backgroundColor}]}

const newFormatDataByRanking = (d = [], level, graphType, currentMeasure, entity) => {

    const result = d;
    const dataObj = result && result[result.sequence[0]].returnData
    const entities = dataObj.entities;
    const graphData = dataObj.graphdata;
    const datasets = [];
    const labels = [];
    const hcPieChartData = [];
    const lineTension = 0;
    const barThickness = "flex";
    const fill = false;
    const borderWidth = 1;
    const allData = []
    for (let i = 0; i < entities.length; ++i) {
        allData.push({
            label: entities[i],
            data: graphData[entities[i].entity_name],
        });
    }

    if (level === ENTITY) {
        allData.sort((a, b) => b.data[currentMeasure] - a.data[currentMeasure]);
        const sortentities = allData.map(e => e.label);
        const entityColors = getRandomUniqueColor(sortentities.length);
        const measure = currentMeasure;
        labels.push("Companies");
        sortentities && sortentities.forEach((ent, idx) => {
            const label = ent.entity_name;
            const backgroundColor = (useDynamicEntityColors) ? (ent.color_code !== "#000000") ? ent.color_code : entityColors[idx] : entityColors[idx];
            const borderColor = backgroundColor;
            const currVal = parseData(graphData[label][measure], true);
            const data = [currVal];
            datasets.push({ label, backgroundColor, barThickness, borderColor, borderWidth, data, fill, lineTension });
            hcPieChartData.push({ name: label, y: currVal, backgroundColor });
        });
        if (graphType === BAR_VERTICAL) {
            return { labels, datasets };
        }
        else if (graphType === PIE) {
            const entityNames = sortentities.map((ent) => ent.entity_name);
            return { labels: entityNames, datasets, hcPieChartData };
        }
        else {
            return { labels: [], datasets: [], hcPieChartData: [{}] };
        }
    }
    else {
        const measure = currentMeasure;
        const entNames = entities && entities.map((ent) => ent.entity_name);
        // const journalists = dataObj && dataObj.journalist.map((j) => j.source_name);
        // const keywords = graphData && Object.keys(graphData);
        let level2Keys = graphData && Object.keys(graphData);//journalists;

        let allData = [];
        for (let i = 0; i < level2Keys.length; ++i) {
            if (graphType === PIE) {
                if (graphData[level2Keys[i]].hasOwnProperty(entity)) {
                    allData.push({
                        label: level2Keys[i],
                        data: graphData[level2Keys[i]][entity],
                        entities: entity
                    });
                }
            }
            else {

                entities && entities.forEach((ent) => {
                    if (graphData[level2Keys[i]].hasOwnProperty(ent.entity_name)) {
                        allData.push({
                            label: level2Keys[i],
                            data: graphData[level2Keys[i]][ent.entity_name],
                            entities: ent.entity_name
                        });
                    }

                })
            }
        }
        allData.sort((a, b) => b.data[measure] - a.data[measure]);
        const sortedLabels = allData.map(e => e.label);
        let sortedLabelsList;
        if (level === CITY) sortedLabelsList = [...new Set(sortedLabels.map(x => x))]
        else sortedLabelsList = [...new Set(sortedLabels.map(x => x))].slice(0, 10)
        const color = getRandomUniqueColor(sortedLabelsList.length);
        const legendSet = [];
        const legendSetLength = Math.ceil(level2Keys.length / 10);
        // for (let x = 1, y = 0; x <= 10; x++) {
        const set = [];
        const pieSet = [];
        sortedLabelsList.forEach((lab, idx) => {
            const label = lab;
            const backgroundColor = color[idx];
            const borderColor = color[idx];
            let currVal = 0;
            const data = [];
            if (graphType === BAR_STACKED_EQUAL_HEIGHT) {
                entities && entities.forEach((ent) => {
                    if (graphData.hasOwnProperty(lab) && graphData[lab].hasOwnProperty(ent.entity_name)) {
                        currVal = parseData(graphData[lab][ent.entity_name][measure], true);
                    }
                    data.push(currVal);
                });
                set.push({ label, backgroundColor, barThickness, borderColor, borderWidth, data, fill, lineTension });
            } else if (graphType === PIE) {
                if (graphData.hasOwnProperty(lab) && graphData[lab].hasOwnProperty(entity)) {
                    currVal = parseData(graphData[lab][entity][measure], true);
                }
                pieSet.push({ name: label, y: currVal, backgroundColor });
            }
        });
        legendSet.push({ labels: entNames, datasets: set, hcPieChartData: pieSet });
        // y = x * 10;
        // }
        return legendSet;
    }
}
//{datasets: {label: "", backgroundColor: "", barThcikness: "", borderColor: ""/[], borderWidth: 1, data: [], fill: false, lineTension: 0}}
//{labels: [], datasets: [], hcPieChartData: [{name, y, backgroundColor}]}

const newFormatDataByTrend = (d = [], level, graphType, currentMeasure, entity) => {
    if (graphType === PIE) {
        return { labels: [], datasets: [], hcPieChartData: [{}] };
    }
    const result = d;
    const dataObj = result && result[result.sequence[0]].returnData;
    const entities = dataObj && dataObj.entities;
    const graphData = dataObj && dataObj.graphdata;
    const journalits = dataObj && dataObj.journalist;
    const keywords = dataObj && dataObj.keywords;
    const editions = dataObj && dataObj.editions;
    let measure = currentMeasure;
    const color = entities && getRandomUniqueColor(entities.length);
    const datasets = [];
    const labels = graphData && Object.keys(graphData).sort();
    const publications = dataObj.publications;
    const level1Keys = graphData && Object.keys(graphData).sort();
    const level2Keys = [];
    level1Keys && level1Keys.forEach((date) => {
        const currLevel2KeyArray = Object.keys(graphData[date]);
        currLevel2KeyArray.length > 0 && currLevel2KeyArray.forEach((val, idx) => {
            if (level2Keys.indexOf(val) === -1) {
                level2Keys.push(val);
            }
        });
    });
    let loopData;
    let loopName;
    // if (level === ENTITY) {
    //     loopData = entities;
    //     loopName = "entity_name";
    // } else if (level === JOURNALIST) {
    //     loopData = journalits;
    //     loopName = "source_name";
    // } else if (level === KEYWORD) {
    //     loopData = keywords;
    //     // measure = currentMeasure === "wordcounttotal" ? "wordcnttotal" : 
    //     // currentMeasure === "article_count" ? "articlecnt" : 
    //     //     currentMeasure;
    // } else if (level === PUBLICATION) {
    //     loopData = publications;
    //     loopName = "publication";
    // } else if (level === CITY) {
    //     loopData = editions;
    //     loopName = "edition";
    //     //console.log("Add Level HERE");
    // }

    let allData = [];
    for (let i = 0; i < level1Keys.length; ++i) {
        level2Keys && level2Keys.forEach((level2) => {
            if (level === ENTITY) {
                if (graphData[level1Keys[i]].hasOwnProperty(level2)) {
                    allData.push({
                        label: level2,
                        data: graphData[level1Keys[i]][level2],
                        entities: level2
                    });
                }
            } else {
                entities && entities.forEach((ent) => {
                    if (graphData[level1Keys[i]].hasOwnProperty(level2) && graphData[level1Keys[i]][level2].hasOwnProperty(ent.entity_name)) {
                        allData.push({
                            label: level2,
                            data: graphData[level1Keys[i]][level2][ent.entity_name],
                            entities: ent.entity_name
                        });
                    }
                })
            }

        })
    }

    allData.sort((a, b) => b.data[measure] - a.data[measure]);
    const sortedLabels = allData.map(e => e.label);
    let sortedLabelsList;
    if (level === CITY) sortedLabelsList = [...new Set(sortedLabels.map(x => x))]
    else sortedLabelsList = [...new Set(sortedLabels.map(x => x))].slice(0, 10)

    loopData = level2Keys;
    sortedLabelsList && sortedLabelsList.forEach((elm, idx) => {
        const label = elm; //(level === KEYWORD) ? elm : elm[loopName];
        const backgroundColor = color[idx];
        const barThickness = "flex";
        const borderColor = color[idx];
        const borderWidth = 1;
        const data = [];
        const fill = false;
        const lineTension = 1;
        labels && labels.forEach((date) => {
            if (level === ENTITY && graphData[date].hasOwnProperty(label)) {
                const currVal = parseData(graphData[date][label][measure], true);
                data.push(currVal);
            } else if (graphData[date].hasOwnProperty(label) && graphData[date][label].hasOwnProperty(entity)) {
                const currVal = parseData(graphData[date][label][entity][measure], true);
                data.push(currVal);
            }
            // else if (level === PUBLICATION && graphData[date].hasOwnProperty(entity) && graphData[date][entity].hasOwnProperty(label)) {
            //     const currVal = parseData(graphData[date][label][entity][measure], true);
            //     data.push(currVal);
            // } else if (level === CITY && graphData[date].hasOwnProperty(label) && graphData[date][label].hasOwnProperty(entity)) {
            //     const currVal = parseData(graphData[date][label][entity][measure], true);
            //     data.push(currVal);
            // } else if (level === JOURNALIST && graphData[date].hasOwnProperty(label) )
            else {
                data.push(0);
            }
        });
        datasets.push({ label, backgroundColor, barThickness, borderColor, borderWidth, data, fill, lineTension });
    });
    return { labels, datasets };
}

const parseData = (value, float = false) => {
    let return_value = (float) ? Math.round(parseFloat(value * 100, 10)) / 100 : parseInt(value, 10);
    if (Number.isNaN(return_value)) {
        let newevalue = value.replace(/,/g, '')
        newevalue = (float) ? Math.round(parseFloat(newevalue * 100, 10)) / 100 : parseInt(newevalue, 10)
        return newevalue;
    }
    return return_value;
}
